import React from 'react';
import { Icon } from 'antd';
import "./style.less";

function getType(name, url) {
    const type = name.split(".").last();
    const fontSize = "22px";
    switch (true) {
        case ["jpg", "png", "jpeg", "gif"].includes(type):
            return <img width="100%" src={url} />
        case ["xls", "xlsx"].includes(type):
            return <Icon style={{ color: "#eb2f96", fontSize }} type="file-excel" />
        case ["ppt", "pptx"].includes(type):
            return <Icon style={{ color: "#fa8c16", fontSize }} type="file-ppt" />
        case ["md"].includes(type):
            return <Icon style={{ color: "#52c41a", fontSize }} type="file-markdown" />
        case ["pdf"].includes(type):
            return <Icon style={{ color: "#13c2c2", fontSize }} type="file-pdf" />
        case ["txt"].includes(type):
            return <Icon style={{ color: "#1890ff", fontSize }} type="file-text" />
        case ["doc", "docx"].includes(type):
            return <Icon style={{ color: "#722ed1", fontSize }} type="file-word" />
        case ["zip", "rar", "gz", "rar4"].includes(type):
            return <Icon style={{ color: "#eb2f96", fontSize }} type="file-zip" />
        case ["avi", "mov", "asf", "wmv", "nvai", "mov", "mp4", "flv"].includes(type):
            return <Icon style={{ color: "#eb2f96", fontSize }} type="video-camera" />
    }
    return <Icon type="file-unknown" />;
}

function FileList({ data = [{ name: "", url: "",id:"" }], onRemove }) {

    return (
        <div className="com-fileList child-top-xs">
            {data.map(({ name, url,id }) => {
                const show = getType(name, url,id);
                return (
                    <div className="com-fileList__item flex ver child-left-sm">
                        {/*<div className="com-fileList__item-type flex center">{show}</div>*/}
                        {id}
                        <Icon type="paper-clip" className="copy"  />
                        <a href={url} target="_blank" className="nowrap-ellipsis full" style={{ lineHeight: "normal" }}>{name}</a>
                        {/*<Icon type="link" className="copy" data-clipboard-text={url} />*/}
                        {Boolean(onRemove) && <Icon type="delete" onClick={onRemove} />}
                    </div>
                )
            })}
        </div>
    )
}

export default FileList;